// Pre-file season helpers for the TY2026 (2026-2027) rollover.
//
// Before the IRS opens TY2026 e-file (midnight Eastern, July 1, 2026), the
// 2026-2027 period is "pre-file": returns are accepted, deferred, and submitted
// automatically on July 1. On/after that moment 2026-2027 is just the current
// period and behaves like any normal filing (immediate submission).

export const PREFILE_PERIOD = '2026-2027';

// Midnight Eastern (EDT, UTC-4) on July 1, 2026.
export const TY2026_EFILE_OPEN = new Date('2026-07-01T00:00:00-04:00');

// True while the given period is still in pre-file mode (deferred).
export function isPrefileActive(taxPeriod, now = new Date()) {
  return taxPeriod === PREFILE_PERIOD && now < TY2026_EFILE_OPEN;
}

// True once the TY2026 season has opened (July 1, 2026 ET or later).
export function isSeasonOpen(now = new Date()) {
  return now >= TY2026_EFILE_OPEN;
}
